import { forwardRef, useEffect, useLayoutEffect, useState } from 'react';
import { UserWidget } from '@/common/constants/online.homepagegateway.api';
import { useSelector } from 'react-redux';
import { AppState } from '@/react-app-env';
import { getWidgetPadding } from '@/common/utilities/widgetHelper';
import WidgetWrapper from '../widgets/WidgetWrapper';

interface ChildComponentProps {
  widget: UserWidget;
  style?: React.CSSProperties;
  onResizeCallback: (index: number, height: number) => void;
}
export const GridLayoutItem = forwardRef<HTMLDivElement, ChildComponentProps>(({widget, onResizeCallback, style, ...otherProps}, ref) => {
  const windowWidthChanged = useSelector((state: AppState) => state.widgetsState?.windowWidthChanged);
  const [padding, setPadding] = useState({left: 32, bottom: 32})
  const [triggerLayoutEffect, setTriggerLayoutEffect] = useState(1);
  let timeoutId: any;

  useEffect(() => {
    const padding = getWidgetPadding(window.innerWidth)
    setPadding({left: padding.left, bottom: padding.bottom});
  }, [window.innerWidth])
  
  const getNodeHeight = (node: any): number => {
    return node.offsetHeight || 0;
  };
 
  const getElementHeight = (element: any): number => {
    if (!element) return 0;
   
    const height = element.offsetHeight;
   
    if (!element.childNodes) return height;
   
    // Get the first child node with a valid height
    const childHeight = Array.from(element.childNodes)
      .map(getNodeHeight)
      .find(h => h > 0);
     
    return childHeight || height;
  };
 
  useLayoutEffect(() => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const height = getElementHeight((ref as any).current);
     
      if (height) {
        onResizeCallback(widget.id, height);
      }
    }, 200);
   
  }, [(ref as any).current, widget.currentLayout.forceRender, windowWidthChanged, triggerLayoutEffect]);

  const triggerResizeCallback = () => {
    setTriggerLayoutEffect(t => t + 1);
  }

  return (
    <div ref={ref}
        style={
          {
            paddingLeft: widget.currentLayout.x === 0 ? 0 : padding.left,
            ...style
          }
        }
        {...otherProps}>
      <WidgetWrapper widget={widget} triggerResize={triggerResizeCallback}></WidgetWrapper>
    </div>
  );
})
export default GridLayoutItem;